// extracted by mini-css-extract-plugin
export default {"container":"_1Hhu7","list":"k+88n","listItem":"Z6daP"};